module.exports = __webpack_public_path__ + "static/media/ANAHUAC_independecia_maxima.19ccdd8e.png";